import React from 'react';
import { Link } from 'react-router-dom';
import SubscriptionSection from '../components/SubscriptionSection';
import '../styles/Philosophy.css';

const Philosophy = () => {
  const relatedPages = [
    {
      title: 'Company Profile',
      path: '/about-us/profile',
      description: 'Learn more about our company, services, projects, and why choose us.',
      image: '/images/1023.png'
    },
    {
      title: 'Our History',
      path: '/about-us/history',
      description: 'Discover our journey from foundation to the present day.',
      image: '/images/6.png'
    },
    {
      title: 'Our Projects',
      path: '/projects',
      description: 'Explore our latest work across different sectors.',
      image: '/images/26.jpg'
    }
  ];

  return (
    <main className="philosophy-main">
      {/* Hero Banner */}
      <div className="philosophy-hero">
        <img
          src="/images/29.png"
          alt="City Skyline with Digital Network"
          className="philosophy-hero-image"
        />
        <div className="philosophy-hero-overlay"></div>
        
      </div>
      
      {/* Main Content */}
      <section className="philosophy-content">
        <div className="philosophy-container">
          {/* Tiêu đề lớn */}
          <h2 className="philosophy-main-title">Sứ mệnh - Tầm nhìn - Giá trị cốt lõi</h2>

          {/* Box quote lớn */}
          <div className="philosophy-quote-container">
            <div className="philosophy-quote-box">
              <div className="philosophy-quote-mark philosophy-quote-left">"</div>
              <div className="philosophy-quote-mark philosophy-quote-right">"</div>
              <p className="philosophy-quote-text">
                <span className="philosophy-company-name">Phúc An Solutions</span> là đơn vị cung cấp giải pháp công nghệ - thiết kế - xây dựng uy tín, chuyên nghiệp. Chúng tôi mang đến dịch vụ trọn gói từ tư vấn công nghệ, lắp đặt camera, thiết kế nội thất, giải pháp CNTT đến năng lượng mặt trời cho doanh nghiệp và cá nhân.
              </p>
            </div>
          </div>
          
          {/* Block 1: TẦM NHÌN */}
          <div className="philosophy-section">
            <div className="philosophy-text-content philosophy-text-left">
              <h3 className="philosophy-section-title">TẦM NHÌN</h3>
              <p className="philosophy-section-text">
                Tiên phong trong xu hướng chuyển đổi xanh tại khu vực miền Nam, Phúc An Solutions không ngừng đổi mới để trở thành biểu tượng hàng đầu trong tư vấn, thiết kế và thi công công trình tích hợp hệ thống năng lượng mặt trời – thông minh và hiệu quả.
              </p>
              <p className="philosophy-section-text">
                Vươn xa khỏi phạm vi miền Đông Nam Bộ, chúng tôi đặt mục tiêu mở rộng toàn quốc với hệ sinh thái giải pháp năng lượng đồng bộ, nơi công nghệ, con người và thiên nhiên cùng cộng sinh, phát triển mạnh mẽ trong một vòng tròn xanh hài hòa, bền vững.
              </p>
            </div>
            <div className="philosophy-image-content philosophy-image-right">
              <div className="philosophy-image-container">
                <img src="/images/26.jpg" alt="Tầm Nhìn" className="philosophy-section-image" />
              </div>
            </div>
          </div>

          {/* Block 2: SỨ MỆNH */}
          <div className="philosophy-section">
            <div className="philosophy-image-content philosophy-image-left">
              <div className="philosophy-image-container">
                <img src="/images/27.jpg" alt="Sứ Mệnh" className="philosophy-section-image" />
              </div>
            </div>
            <div className="philosophy-text-content philosophy-text-right">
              <h3 className="philosophy-section-title">SỨ MỆNH</h3>
              <p className="philosophy-section-text">
                Khởi nguồn từ một đội ngũ nhỏ với 11 con người chung chí hướng, Phúc An Solutions vươn lên từ trong thử thách để khẳng định mình trên hành trình tiên phong chuyển đổi xanh.
              </p>
              <p className="philosophy-section-text">
                Chúng tôi không chỉ cung cấp giải pháp – chúng tôi kiến tạo giá trị thực tiễn: tối ưu chi phí, nâng cao hiệu quả và mang lại sự phù hợp tối đa cho từng khách hàng. Phúc An Solutions là đối tác chiến lược, tận tâm đồng hành cùng khách hàng trong mọi giai đoạn – từ khởi động đến vận hành ổn định – với tinh thần đổi mới không ngừng nghỉ và cam kết xây dựng những giá trị bền vững cho tương lai.
              </p>
            </div>
          </div>
              
          {/* Block 3: GIÁ TRỊ CỐT LÕI */}
          <div className="philosophy-section">
            <div className="philosophy-text-content philosophy-text-left">
              <h3 className="philosophy-section-title">GIÁ TRỊ CỐT LÕI</h3>
              <p className="philosophy-section-text">
                <span className="philosophy-highlight">Giải pháp tiên tiến – Kiến tạo tương lai:</span> Chúng tôi không chỉ cung cấp giải pháp, chúng tôi kiến tạo tương lai – bằng tư duy tiên tiến, công nghệ hiện đại và sự thấu hiểu sâu sắc những gì khách hàng cần để bứt phá trong một thế giới luôn vận động.
              </p>
              <p className="philosophy-section-text">
                <span className="philosophy-highlight">Tiêu chuẩn cao và tư duy khác biệt:</span> Chúng tôi không ngại đặt câu hỏi, không ngại thách thức lối mòn – vì chúng tôi tin rằng sự sáng tạo là gốc rễ của mọi bước tiến vững bền.
              </p>
              <p className="philosophy-section-text">
                <span className="philosophy-highlight">Cam kết tận tâm:</span> Dù là một chi tiết nhỏ hay một dự án lớn, chúng tôi luôn theo đuổi sự chỉn chu, minh bạch và tận tâm cho đến khi tạo ra kết quả tốt nhất.
              </p>
              <p className="philosophy-section-text">
                <span className="philosophy-highlight">Kết nối chân thành – Đồng hành bền vững:</span> Chúng tôi xây dựng mối quan hệ dựa trên sự lắng nghe, tôn trọng và kết nối chân thành – với khách hàng, đối tác và từng thành viên trong đội ngũ. Đó là nền tảng để cùng nhau phát triển bền vững.
              </p>
            </div>
            <div className="philosophy-image-content philosophy-image-right">
              <div className="philosophy-image-container">
                <img src="/images/28.png" alt="Giá Trị Cốt Lõi" className="philosophy-section-image" />
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* Related Content Section */}
      <section className="philosophy-related">
        <div className="philosophy-related-container">
          <h2 className="philosophy-related-title">Tìm Hiểu Thêm Về Chúng Tôi</h2>
          
          <div className="philosophy-related-grid">
            {relatedPages.map((page, index) => (
              <div
                key={page.path}
                className="philosophy-related-card"
                style={{ animationDelay: `${0.2 * index}s` }}
              >
                <div className="philosophy-related-image">
                  <img
                    src={page.image}
                    alt={page.title}
                    className="philosophy-card-image"
                  />
                </div>
                <div className="philosophy-related-content">
                  <h3 className="philosophy-card-title">{page.title}</h3>
                  <p className="philosophy-card-description">{page.description}</p>
                  <Link 
                    to={page.path}
                    className="philosophy-card-link"
                  >
                    Tìm hiểu thêm
                    <svg 
                      xmlns="http://www.w3.org/2000/svg" 
                      className="philosophy-arrow-icon" 
                      fill="none" 
                      viewBox="0 0 24 24" 
                      stroke="currentColor"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Subscription Section */}
      <SubscriptionSection />
    </main>
  );
};

export default Philosophy; 